"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditorActions = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _editorButtons = require("./editor-buttons");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var EditorActions = exports.EditorActions = function EditorActions(_ref) {
  var slot = _ref.slot,
    saveDisabled = _ref.saveDisabled,
    _ref$syncing = _ref.syncing,
    syncing = _ref$syncing === void 0 ? false : _ref$syncing,
    onSave = _ref.onSave,
    _ref$onBack = _ref.onBack,
    onBack = _ref$onBack === void 0 ? null : _ref$onBack,
    onCancel = _ref.onCancel;
  if (slot === null) return null;
  return /*#__PURE__*/(0, _reactDom.createPortal)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      type: "button",
      className: _editorButtons.PRIMARY_BUTTON_CLASS,
      disabled: saveDisabled,
      onClick: onSave,
      children: _editorButtons.SAVE_BUTTON_LABEL
    }), onBack === null ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      type: "button",
      className: _editorButtons.SECONDARY_BUTTON_CLASS,
      onClick: onBack,
      children: _editorButtons.BACK_BUTTON_LABEL
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      type: "button",
      className: _editorButtons.SECONDARY_BUTTON_CLASS,
      onClick: onCancel,
      children: _editorButtons.CANCEL_BUTTON_LABEL
    }), syncing ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      role: "status",
      "aria-label": _editorButtons.SYNCING_WITH_DOCUMENT_LABEL,
      title: _editorButtons.SYNCING_WITH_DOCUMENT_LABEL,
      className: "h-3 w-3 flex-shrink-0 rounded-full border-2 border-primary border-t-transparent animate-spin"
    }) : null]
  }), slot);
};